var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-group" }, [
    _c("div", { staticClass: "filters-group-label" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filters-group-outer", class: { active: _vm.model } },
      [
        _c(
          "label",
          { staticClass: "filters-checkbox", attrs: { for: _vm.type } },
          [_vm._v("\n            " + _vm._s(_vm.buttonTitle) + "\n        ")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model,
              expression: "model",
            },
          ],
          staticStyle: { visibility: "hidden" },
          attrs: { id: _vm.type, type: "checkbox" },
          domProps: {
            value: _vm.value,
            checked: Array.isArray(_vm.model)
              ? _vm._i(_vm.model, _vm.value) > -1
              : _vm.model,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.model,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = _vm.value,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.model = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.model = $$c
                }
              },
              _vm.showResultsButtonFn,
            ],
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }